import {
  faAddressBook,
  faAnalytics,
  faArchive,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightToBracket,
  faArrowRotateLeft,
  faArrowRotateRight,
  faArrowUp,
  faArrowsSplitUpAndLeft,
  faAt,
  faBackspace,
  faBan,
  faBell,
  faBellSlash,
  faBooks,
  faBoxOpenFull,
  faBriefcase,
  faBuilding,
  faCalculator,
  faCalendar,
  faChartBar,
  faCheckCircle,
  faCheckToSlot,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronsUp,
  faCircle,
  faCircleDollar,
  faClipboardCheck,
  faClock,
  faClone,
  faCloud,
  faCode,
  faCog,
  faCommand,
  faComment,
  faCommentAltSlash,
  faCommentDots,
  faCommentLines,
  faCommentsAlt,
  faCompressAlt,
  faCopy,
  faCreditCard,
  faCubes,
  faDizzy,
  faDollarSign,
  faDoorOpen,
  faDotCircle,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faEquals,
  faExclamationCircle,
  faExclamationSquare,
  faExpand,
  faExpandAlt,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFax,
  faFile,
  faFileAlt,
  faFileArchive,
  faFilePdf,
  faFileSignature,
  faFileSpreadsheet,
  faFileWord,
  faFilter,
  faFlag,
  faFolder,
  faFontCase,
  faFrownOpen,
  faGavel,
  faGlobe,
  faGrimace,
  faGrin,
  faGrinBeam,
  faGrinStars,
  faHeart,
  faHighlighter,
  faHome,
  faImagePolaroid,
  faInbox,
  faInfoCircle,
  faItalic,
  faKey,
  faKeyboard,
  faKissWinkHeart,
  faLightbulbOn,
  faLink,
  faLock,
  faLongArrowUp,
  faMapMarkerAlt,
  faMeh,
  faMessageLines,
  faMicrophone,
  faMicrophoneSlash,
  faMinus,
  faMoneyCheck,
  faMusic,
  faOption,
  faPaperPlane,
  faPaperclip,
  faPause,
  faPauseCircle,
  faPen,
  faPencil,
  faPhone,
  faPhoneSquare,
  faPhoneXmark,
  faPlay,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPollH,
  faQuestionCircle,
  faRectangleXmark,
  faReply,
  faReplyAll,
  faRightFromBracket,
  faRightToBracket,
  faSadTear,
  faSearch,
  faSearchPlus,
  faShare,
  faShieldCheck,
  faSmile,
  faSmileBeam,
  faSortAmountDown,
  faSplit,
  faSquarePollHorizontal,
  faStar,
  faStickyNote,
  faStop,
  faStopCircle,
  faSync,
  faTag,
  faText,
  faTextHeight,
  faThumbsDown,
  faThumbsUp,
  faTicket,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUnderline,
  faUnlink,
  faUp,
  faUpload,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserFriends,
  faUserHeadset,
  faUserPlus as faUserPlusRegular,
  faUserShield,
  faUserSlash,
  faUserTimes,
  faUsers,
  faUsersClass,
  faVideo,
  faVideoSlash,
  faVoicemail,
  faVolume,
  faVolumeSlash,
  faVolumeXmark,
  faWandMagicSparkles,
  faWarehouseFull,
  faWindowMaximize,
} from '@fortawesome/pro-regular-svg-icons';

const proRegularSvgIcons = {
  add: faPlus,
  addCircle: faPlusCircle,
  addUser: faUserPlusRegular,
  addressBookRegular: faAddressBook,
  analytics: faAnalytics,
  archive: faArchive,
  arrowsSplitUpAndLeft: faArrowsSplitUpAndLeft,
  at: faAt,
  attachment: faPaperclip,
  back: faArrowLeft,
  backspace: faBackspace,
  books: faBooks,
  briefcase: faBriefcase,
  building: faBuilding,
  calculator: faCalculator,
  calendar: faCalendar,
  calendarRegular: faCalendar, // TODO: delete this one
  callFlow: faSplit,
  cancel: faBan,
  charts: faSquarePollHorizontal,
  checkCircle: faCheckCircle,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  chevronUp: faChevronUp,
  chevronUpDouble: faChevronsUp,
  clipboard: faClipboardCheck,
  close: faTimes,
  closeSquare: faRectangleXmark,
  cloud: faCloud,
  code: faCode,
  faComment: faComment,
  comments: faCommentsAlt,
  commentLines: faCommentLines,
  compress: faCompressAlt,
  contacts: faUserCircle,
  copy: faCopy,
  delete: faTrashAlt,
  doc: faFileWord,
  dollar: faDollarSign,
  dotCircle: faDotCircle,
  down: faArrowDown,
  download: faDownload,
  edit: faEdit,
  envelopeOpen: faEnvelopeOpen,
  equals: faEquals,
  excel: faFileSpreadsheet,
  exclamation: faExclamationCircle,
  expand: faExpandAlt,
  fax: faFax,
  file: faFile,
  fileAlt: faFileAlt,
  filter: faFilter,
  flag: faFlag,
  folder: faFolder,
  font: faFontCase,
  fontSize: faTextHeight,
  forward: faShare,
  front: faArrowRight,
  gavel: faGavel,
  graph: faChartBar,
  headset: faUserHeadset,
  help: faQuestionCircle,
  hide: faEyeSlash,
  home: faHome,
  image: faImagePolaroid,
  inbox: faInbox,
  info: faInfoCircle,
  insights: faLightbulbOn,
  italic: faItalic,
  key: faKey,
  link: faLink,
  location: faMapMarkerAlt,
  lock: faLock,
  longUp: faLongArrowUp,
  mail: faEnvelope,
  marker: faHighlighter,
  minus: faMinus,
  mute: faMicrophoneSlash,
  newWindow: faExternalLink,
  notification: faBell,
  notificationOff: faBellSlash,
  pause: faPause,
  pauseCircle: faPauseCircle,
  pdf: faFilePdf,
  pen: faPen,
  pencil: faPencil,
  phone: faPhone,
  phoneSquare: faPhoneSquare,
  phoneXmark: faPhoneXmark,
  play: faPlay,
  playCircle: faPlayCircle,
  preview: faSearchPlus,
  record: faCircle,
  refresh: faSync,
  remove: faTimesCircle,
  removeUser: faUserTimes,
  reply: faReply,
  replyAll: faReplyAll,
  report: faPollH,
  ringtones: faMusic,
  room: faDoorOpen,
  search: faSearch,
  send: faPaperPlane,
  settings: faCog,
  smile: faSmile,
  sms: faCommentDots,
  sortDown: faSortAmountDown,
  star: faStar,
  stickyNote: faStickyNote,
  stop: faStop,
  stopCircle: faStopCircle,
  tag: faTag,
  team: faUsers,
  ticket: faTicket,
  time: faClock,
  clone: faClone,
  underline: faUnderline,
  unmute: faMicrophone,
  up: faArrowUp,
  upload: faUpload,
  url: faGlobe,
  user: faUser,
  userCheck: faUserCheck,
  userSlash: faUserSlash,
  userShield: faUserShield,
  users: faUserFriends,
  videoOff: faVideoSlash,
  videoOn: faVideo,
  voicemail: faVoicemail,
  volume: faVolume,
  volumeSlash: faVolumeSlash,
  volumeXmark: faVolumeXmark,
  watch: faEye,
  window: faWindowMaximize,
  zip: faFileArchive,
  fullScreen: faExpand,
  signature: faFileSignature,
  squareExclamation: faExclamationSquare,
  unLink: faUnlink,
  faArrowCircleLeft,
  faArrowCircleRight,
  faCommentAltSlash,
  faDizzy,
  faEllipsisV,
  faFrownOpen,
  faGrimace,
  faGrin,
  faGrinBeam,
  faGrinStars,
  faHeart,
  faKissWinkHeart,
  faMeh,
  faShieldCheck,
  faSadTear,
  faSmileBeam,
  faUsersClass,
  faThumbsUp,
  faThumbsDown,
  joinMeeting: faArrowRightToBracket,
  joinRoom: faRightToBracket,
  leaveRoom: faRightFromBracket,
  circleDollar: faCircleDollar,
  cancelPresentation: faRectangleXmark,
  automations: faWandMagicSparkles,
  creditCard: faCreditCard,
  boxOpenFull: faBoxOpenFull,
  moneyCheck: faMoneyCheck,
  messageLines: faMessageLines,
  checkToSlot: faCheckToSlot,
  option: faOption,
  shift: faUp,
  command: faCommand,
  arrowRotateLeft: faArrowRotateLeft,
  arrowRotateRight: faArrowRotateRight,
  keyboard: faKeyboard,
  text: faText,
  cubes: faCubes,
  warehouse: faWarehouseFull,
} as const;

export { proRegularSvgIcons };
